/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if (window.boostSDAppConfig) {
    window.boostSDAppConfig.integration = Object.assign({
        labels: 'deco'
    }, window.boostSDAppConfig.integration || {});
}

const wrapAll = (productItem, targetClasses, parentClass, requiredClass = 'required-class') => {
    if (!productItem) return;
    let parent = productItem.querySelector(parentClass);
    if (!parent) return;
    let wrapper = document.createElement('div');
    wrapper.classList.add(requiredClass);

    if (productItem.getElementsByClassName(requiredClass).length === 0) {
        for (let targetClass of targetClasses) {
            let target = productItem.querySelectorAll(targetClass);
            if (!target) continue;
            target.forEach(child => wrapper.append(child));
        }
        parent.append(wrapper);
    } else {
        for (let targetClass of targetClasses) {
            let target = productItem.querySelectorAll(targetClass);
            if (!target) continue;
            target.forEach(child => productItem.querySelector('.' + requiredClass).append(child));
        }
    }

    return wrapper
}

const customize = (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductItem', {
        name: 'Customize product card',
        enabled: true,
        apply: () => ({
            afterRender(element) {
                try {
                    const parentElement = element?.getParentElm();
                    const productData = parentElement?.getParams()?.props?.product || parentElement?.getParams()?.props?.productData || parentElement?.getParams()?.props?.data || parentElement?.getParentElm()?.getParams()?.props?.productData || parentElement?.getParentElm()?.getParentElm()?.getParams()?.props?.product;

                    let productItems = document.querySelectorAll('[data-product-id="' + productData.id + '"]');

                    for (let productItem of productItems) {
                        if (!productItem) continue;

                        // Wrap ATC buttons
                        wrapAll(productItem, ['.boost-sd__product-info .boost-sd__button'], '.boost-sd__product-link:not(.boost-sd__product-link-image) .boost-sd__product-info', 'boost-sd__atc-wl-wrapper');

                        // Custom style for product title
                        if (productItem.querySelector('.boost-sd__product-title')) {
                            const titleEle = productItem.querySelector('.boost-sd__product-title');
                            const currentAttribute = titleEle.getAttribute('style');
                            const newTitleHtml = '<h2 style="' + currentAttribute + '" class="boost-sd__product-title">' + productData.title + '</h2>';

                            titleEle.remove();
                            if (productItem.querySelector('h2.boost-sd__product-title') == null) {
                                productItem.querySelector('.boost-sd__product-info').insertAdjacentHTML('afterbegin', newTitleHtml);
                            }
                        }

                        // Check inventory and update button text
                        if (productItem.querySelector('.boost-sd__atc-wl-wrapper .boost-sd__btn-add-to-cart')) {
                            const cartElm = productItem.querySelector('.boost-sd__atc-wl-wrapper .boost-sd__btn-add-to-cart');
                            let inventoryAvailable = false;

                            for (let variant of productData.variants) {
                                if (variant.inventory_quantity > 0) {
                                    inventoryAvailable = true;
                                    break;
                                }
                            }

                            if (!inventoryAvailable && cartElm.querySelector('.boost-sd__button-text')) {
                                cartElm.querySelector('.boost-sd__button-text').innerText = 'Pre-order';
                            }
                        }
                    }
                } catch (error) {
                    console.warn(error);
                }
            }
        }),
    });

    // Customize QuickView
    componentRegistry.useComponentPlugin('QuickView', {
        name: 'Customize QuickView',
        enabled: true,
        apply: () => ({
            afterRender(element) {
                try {
                    const parentElement = element;
                    const productData = parentElement?.getParams()?.props?.product || parentElement?.getParams()?.props?.productData || parentElement?.getParams()?.props?.data || parentElement?.getParentElm()?.getParams()?.props?.productData || parentElement?.getParentElm()?.getParentElm()?.getParams()?.props?.product;

                    if (productData) {
                        let quickViewModal = document.querySelector('.boost-sd__quick-view[product-id="' + productData.id + '"]');
                        if (quickViewModal) {
                            if (quickViewModal.querySelector('.boost-sd__quick-view-btn .boost-sd__btn-add-to-cart')) {
                                const cartElm = quickViewModal.querySelector('.boost-sd__quick-view-btn .boost-sd__btn-add-to-cart');
                                let inventoryAvailable = false;

                                for (let variant of productData.variants) {
                                    if (variant.inventory_quantity > 0) {
                                        inventoryAvailable = true;
                                        break;
                                    }
                                }

                                if (!inventoryAvailable && cartElm.querySelector('.boost-sd__button-text')) {
                                    cartElm.querySelector('.boost-sd__button-text').innerText = 'Pre-order';
                                }
                            }
                        }
                    }
                } catch (error) {
                    console.warn(error);
                }
            }
        }),
    });
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    customize,
]);
